import { render, staticRenderFns } from "./back-stockproduct.vue?vue&type=template&id=2a49e9fe"
import script from "./back-stockproduct.vue?vue&type=script&lang=ts"
export * from "./back-stockproduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports